import { store } from '../';
import { setErrorDispatcher } from '../../hooks/setErrorDispatcher';

import API from '../../utils/api';
import * as types from './types';
import { GET_REPORT_TERMINALS_BALANCE, RESET_REPORT_GENERAL_BALANCE } from './types';
import { getTranslation } from '../../utils/translation';
import { ENDPOINT_URL, device_URI, BACK_OFFICE_API_ENDPOINT } from '../../constants/defaultValues';
import StaticDataService from '../../services/StaticDataService';

export const getGeneralBalance =
    (startDate = null, endDate = null) =>
    async dispatch => {
        dispatch(setReportsLoading());

        let params = {};
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        try {
            const response = await API.get(`${ENDPOINT_URL}/reports/general`, { params });
            const info = response.data?.info;
            const items = response.data?.item;
            if (!info?.success)
                return store.dispatch(
                    setErrorDispatcher(true, info?.errors[0]?.reason, 'Error', true)
                );
            dispatch({
                type: types.GET_REPORT_GENERAL_BALANCE,
                payload: items,
            });
        } catch (err) {
            console.log(err);
            return store.dispatch(
                setErrorDispatcher(
                    true,
                    getTranslation('generalErrorModalDescription'),
                    getTranslation('generalErrorModalTitle'),
                    false
                )
            );
        }
    };

export const resetGeneralBalance = () => ({
    type: RESET_REPORT_GENERAL_BALANCE,
});

export const getSportBookReport =
    (startDate = null, endDate = null) =>
    async dispatch => {
        dispatch(setReportsLoading());

        let params = {};
        if (startDate) params.startDate = new Date(startDate).getTime();
        if (endDate) params.endDate = new Date(endDate).getTime();
        try {
            const response = await API.get(`${ENDPOINT_URL}/reports/sportsbook`, { params });
            const info = response.data?.info;
            const items = response.data?.item;
            if (!info?.success)
                return store.dispatch(
                    setErrorDispatcher(true, info?.errors[0]?.reason, 'Error', true)
                );
            dispatch({
                type: types.GET_REPORT_SPORT_BOOK,
                payload: items,
            });
        } catch (err) {
            console.log(err);
            return store.dispatch(
                setErrorDispatcher(
                    true,
                    getTranslation('generalErrorModalDescription'),
                    getTranslation('generalErrorModalTitle'),
                    false
                )
            );
        }
    };

export const resetSportsBook = () => ({
    type: types.GET_REPORT_SPORT_BOOK,
    payload: null,
});

export const getWeeklyBalance =
    (startDate = null, endDate = null) =>
    async dispatch => {
        dispatch(setReportsLoading());

        let params = {};
        if (startDate) params.startDate = new Date(startDate).getTime();
        if (endDate) params.endDate = new Date(endDate).getTime();

        try {
            const response = await API.get(`${ENDPOINT_URL}/reports/balance`, { params });
            const info = response.data?.info;
            const items = response.data?.item;
            if (!info?.success)
                return dispatch(setErrorDispatcher(true, info?.errors[0]?.reason, 'Error', true));
            dispatch({
                type: types.GET_REPORT_WEEKLY_BALANCE,
                payload: items,
            });
        } catch (err) {
            console.log(err);
            return dispatch(
                setErrorDispatcher(
                    true,
                    getTranslation('generalErrorModalDescription'),
                    getTranslation('generalErrorModalTitle'),
                    false
                )
            );
        }
    };

export const getTerminalsBalance =
    ({ startDate = null, endDate = null, terminals }) =>
    async dispatch => {
        dispatch(setReportsLoading());

        let params = {};
        if (startDate) params.startDate = new Date(startDate).getTime();
        if (endDate) params.endDate = new Date(endDate).getTime();
        params.terminals = terminals === 'all' ? null : terminals;

        try {
            const response = await API.get(`${ENDPOINT_URL}/reports/balance/terminal`, { params });
            const info = response.data?.info;
            const items = response.data?.item;
            if (!info?.success)
                return dispatch(setErrorDispatcher(true, info?.errors[0]?.reason, 'Error', true));
            dispatch({
                type: types.GET_REPORT_TERMINALS_BALANCE,
                payload: items,
            });
        } catch (err) {
            console.log(err);
            return dispatch(
                setErrorDispatcher(
                    true,
                    getTranslation('generalErrorModalDescription'),
                    getTranslation('generalErrorModalTitle'),
                    false
                )
            );
        }
    };

export const getCashierPaymentsData =
    (startDate = null, endDate = null) =>
    async dispatch => {
        dispatch({
            type: types.SET_CASHIER_PAYMENTS_LOADING,
        });

        let params = {};
        if (startDate) params.startDate = new Date(startDate).getTime();
        if (endDate) params.endDate = new Date(endDate).getTime();
        try {
            const response = await API.get(`${BACK_OFFICE_API_ENDPOINT}/cashier/payments`, {
                params,
            });
            const info = response.data?.info;
            const items = response.data?.item;
            if (!info?.success)
                return store.dispatch(
                    setErrorDispatcher(true, info?.errors[0]?.reason, 'Error', true)
                );
            dispatch({
                type: types.SET_CASHIER_PAYMENTS,
                payload: items,
            });
        } catch (err) {
            console.log(err);
            return store.dispatch(
                setErrorDispatcher(
                    true,
                    getTranslation('generalErrorModalDescription'),
                    getTranslation('generalErrorModalTitle'),
                    false
                )
            );
        }
    };

export const setReportsLoading = () => ({
    type: types.GET_REPORTS_SET_LOADING,
});

export const printBalanceReportCashier = async reportData =>
    await API.post(`${device_URI}/api/print/balance-report/cashier`, reportData);

export const printBalanceReportTerminals = async reportData =>
    await API.post(`${device_URI}/api/print/balance-report/terminals`, reportData);

export const printCashierBalance = async data =>
    await API.post(`${device_URI}/api/print/cashier-balance`, data);

export const getLastAccountingPeriod = () => async dispatch => {
    const { info, item } = await StaticDataService.getLastAccountingPeriod();

    if (!info.success) {
        dispatch(
            setErrorDispatcher(
                true,
                getTranslation('generalErrorModalDescription'),
                getTranslation('generalErrorModalTitle'),
                false
            )
        );
        return {
            startTime: null,
            endTime: null,
        };
    }

    return {
        startTime: item.startDateTime * 1000,
        endTime: item.endDateTime * 1000,
    };
};
